import Landing from "../sections/Landing";

export function HomePage() {
  return (
    <div className="bg-zinc-50">
      <Landing />
    </div>
  );
}
